import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

/**
 * Confirm DROPPING a personal priority (mobile-polish pass). Dropping is
 * REVERSIBLE (restore later), so this is a NEUTRAL confirmation — never the
 * destructive-red styling reserved for Delete. Copy is PRIVATE and explicit:
 * it only moves the owner's own priority out of their active list. No team,
 * manager, alignment, or sharing language (Stage 1, structurally private).
 */
export interface PersonalPriorityDropDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  isAr: boolean;
  busy?: boolean;
  onConfirm: () => void;
}

export function PersonalPriorityDropDialog({
  open,
  onOpenChange,
  isAr,
  busy,
  onConfirm,
}: PersonalPriorityDropDialogProps) {
  const t = (en: string, ar: string) => (isAr ? ar : en);
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="personal-priority-drop">
        <DialogHeader>
          <DialogTitle>
            {t("Drop this personal priority?", "ترك هذه الأولوية الشخصية؟")}
          </DialogTitle>
          <DialogDescription>
            {t(
              "This moves it out of your active priorities. You can restore it later.",
              "هذا ينقلها خارج أولوياتك النشطة. يمكنك استعادتها لاحقًا.",
            )}
          </DialogDescription>
        </DialogHeader>
        {/* Clear breathing room between the body text and the primary action
            (mobile-polish spacing). */}
        <DialogFooter className="mt-4" data-testid="pp-drop-footer">
          <Button
            variant="ghost"
            onClick={() => onOpenChange(false)}
            data-testid="pp-drop-cancel"
          >
            {t("Cancel", "إلغاء")}
          </Button>
          {/* NEUTRAL, never destructive — red is reserved for Delete. The
              `secondary` variant reads as a calm, non-alarming confirm. */}
          <Button
            variant="secondary"
            disabled={busy}
            onClick={onConfirm}
            data-testid="pp-drop-confirm"
          >
            {t("Drop", "ترك")}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
